import { render, staticRenderFns } from "./DeEscalationDataUpdate.vue?vue&type=template&id=3c511ba3&scoped=true&"
import script from "./DeEscalationDataUpdate.vue?vue&type=script&lang=js&"
export * from "./DeEscalationDataUpdate.vue?vue&type=script&lang=js&"
import style0 from "./DeEscalationDataUpdate.vue?vue&type=style&index=0&id=3c511ba3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c511ba3",
  null
  
)

export default component.exports